import { gql } from 'graphql-tag'

export default gql`
  fragment ProductUpdatesProductFragment on ProductUpdatesProduct {
    sys {
      id
    }
    internalName
    name
    icon
  }
`
